var _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMileage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1376 19.8809C41.1571 20.0299 41.1176 20.224 40.9442 20.4777C40.7686 20.7348 40.4744 21.0233 40.0459 21.3333C39.1894 21.9531 37.8837 22.597 36.2049 23.2202C32.855 24.4636 28.1244 25.5859 22.8109 26.2826C17.4973 26.9793 12.6379 27.1145 9.08168 26.7767C7.29944 26.6073 5.87251 26.3217 4.88583 25.9436C4.39217 25.7545 4.03384 25.5516 3.79817 25.3484C3.56559 25.148 3.4776 24.9706 3.45816 24.8216C3.43873 24.6726 3.47824 24.4785 3.65156 24.2248C3.82718 23.9677 4.1214 23.6793 4.54993 23.3692C5.40641 22.7495 6.71205 22.1055 8.39089 21.4824C11.7408 20.2389 16.4714 19.1167 21.7849 18.4199C27.0985 17.7232 31.9579 17.588 35.5141 17.9259C37.2964 18.0952 38.7233 18.3809 39.71 18.7589C40.2036 18.948 40.562 19.151 40.7976 19.3541C41.0302 19.5546 41.1182 19.732 41.1376 19.8809Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5301 26.5935C35.4823 26.7298 35.2816 27.0066 34.5324 27.2307C33.8092 27.4472 32.7686 27.5491 31.45 27.4962C28.8257 27.391 25.333 26.6832 21.6142 25.373C17.8954 24.0628 14.729 22.4244 12.616 20.8606C11.5544 20.0748 10.8062 19.3427 10.3771 18.7202C9.93255 18.0755 9.94868 17.7337 9.99646 17.5975C10.0442 17.4612 10.2449 17.1844 10.9941 16.9603C11.7173 16.7438 12.7579 16.6419 14.0765 16.6948C16.7008 16.8 20.1936 17.5078 23.9123 18.818C27.6311 20.1282 30.7976 21.7666 32.9105 23.3304C33.9721 24.1161 34.7203 24.8483 35.1495 25.4708C35.594 26.1155 35.5778 26.4573 35.5301 26.5935Z",
    stroke: "white",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3384,
    cy: 4.74658,
    rx: 14.3384,
    ry: 4.74658,
    transform: "matrix(0.826925 -0.562312 0.560416 0.828211 8.76953 26.6616)",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.3672,
    cy: 1.36899,
    rx: 1.3672,
    ry: 1.36899,
    transform: "matrix(0.873974 0.485972 -0.484142 0.874989 38.0254 15.5996)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.89512,
    cy: 1.89759,
    rx: 1.89512,
    ry: 1.89759,
    transform: "matrix(0.873975 0.485972 -0.484143 0.874989 14.3887 10.7998)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3827 21.9999C43.3827 33.6543 33.9585 43.0999 22.3359 43.0999C10.7132 43.0999 1.28906 33.6543 1.28906 21.9999C1.28906 10.3455 10.7132 0.899902 22.3359 0.899902C33.9585 0.899902 43.3827 10.3455 43.3827 21.9999Z",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/mileage.d4270c8bcbcff00c3ca14c5d1477f864.svg";
export { ForwardRef as ReactComponent };